// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-ADF47E85-85A8-4666-9594-DAE5C898EA43 .drawingBuffer {\n  display: none;\n}\n", "",{"version":3,"sources":["webpack://src/uicomponents/components/barcodeReader/barcodeReader.less"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR","sourcesContent":["#V-ADF47E85-85A8-4666-9594-DAE5C898EA43{\n    & .drawingBuffer{\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
